/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type DeleteCustomDetectionRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteCustomDetectionRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteCustomDetectionRuleSecurity = {
  option1?: DeleteCustomDetectionRuleSecurityOption1 | undefined;
  option2?: DeleteCustomDetectionRuleSecurityOption2 | undefined;
};

export type DeleteCustomDetectionRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type DeleteCustomDetectionRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteCustomDetectionRuleSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteCustomDetectionRuleSecurityOption1$Outbound,
    DeleteCustomDetectionRuleSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteCustomDetectionRuleSecurityOption1ToJSON(
  deleteCustomDetectionRuleSecurityOption1:
    DeleteCustomDetectionRuleSecurityOption1,
): string {
  return JSON.stringify(
    DeleteCustomDetectionRuleSecurityOption1$outboundSchema.parse(
      deleteCustomDetectionRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteCustomDetectionRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteCustomDetectionRuleSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteCustomDetectionRuleSecurityOption2$Outbound,
    DeleteCustomDetectionRuleSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteCustomDetectionRuleSecurityOption2ToJSON(
  deleteCustomDetectionRuleSecurityOption2:
    DeleteCustomDetectionRuleSecurityOption2,
): string {
  return JSON.stringify(
    DeleteCustomDetectionRuleSecurityOption2$outboundSchema.parse(
      deleteCustomDetectionRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteCustomDetectionRuleSecurity$Outbound = {
  Option1?: DeleteCustomDetectionRuleSecurityOption1$Outbound | undefined;
  Option2?: DeleteCustomDetectionRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteCustomDetectionRuleSecurity$outboundSchema: z.ZodMiniType<
  DeleteCustomDetectionRuleSecurity$Outbound,
  DeleteCustomDetectionRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteCustomDetectionRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteCustomDetectionRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteCustomDetectionRuleSecurityToJSON(
  deleteCustomDetectionRuleSecurity: DeleteCustomDetectionRuleSecurity,
): string {
  return JSON.stringify(
    DeleteCustomDetectionRuleSecurity$outboundSchema.parse(
      deleteCustomDetectionRuleSecurity,
    ),
  );
}

/** @internal */
export type DeleteCustomDetectionRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const DeleteCustomDetectionRuleRequest$outboundSchema: z.ZodMiniType<
  DeleteCustomDetectionRuleRequest$Outbound,
  DeleteCustomDetectionRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    riskIDRequestBody: RiskIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      riskIDRequestBody: "RiskIDRequestBody",
    });
  }),
);

export function deleteCustomDetectionRuleRequestToJSON(
  deleteCustomDetectionRuleRequest: DeleteCustomDetectionRuleRequest,
): string {
  return JSON.stringify(
    DeleteCustomDetectionRuleRequest$outboundSchema.parse(
      deleteCustomDetectionRuleRequest,
    ),
  );
}
